/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import NotificationBar from '@trdk/style/NotificationBar';
import { connect } from 'react-redux';
import * as yup from 'yup';
import { doFetch } from '../../../../services/fetch/fetch.actions';
import DefaultForm from '../../../../components/default-form';
import { Fetch } from '../../../../services/fetch/fetch-service';
import { fetchProfile, fetchAddSelfPolitician } from '../../../../services/politician/profile-service';

const schema = yup.object().shape({
  fnr: yup.string().matches(/^[0-9]{11}$/, 'Fødselsnummer må være 11 siffer').required('Fødselsnummer er påkrevd'),
  epost: yup.string().email().required('Epost påkrevd'),
  fornavn: yup.string().required('Fornavn er påkrevd'),
  etternavn: yup.string().required('Etternavn er påkrevd'),
  adresse: yup.string().required('Adresse påkrevd'),
  parti: yup.string().required('Parti påkrevd'),
  gender: yup.string().required('Kjønn påkrevd'),
  postnr: yup.number().typeError('Kan ikke inneholde tekst').required('Postnummer påkrevd'),
  poststed: yup.string().required('Poststed påkrevd'),
  tlfprivat: yup.string().matches(/^[0-9]{1,8}$/, 'Telefonnummer ikke gyldig').required('Telefonnummer påkrevd'),
  arbeidssted: yup.string(),
  bankkontonummer: yup.number().required('Bankkontonr. påkrevd'),
  generalInfo: yup.string(),
  // stilling: yup.string().required('Stilling påkrevd'),
});

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      localError: undefined,
      pnr: undefined,
      error: undefined,
    };
  }

  componentDidMount = () => {
    const { profile: { fetched, fetching }, dispatch } = this.props;
    const { pnr } = this.state;

    if (!fetched && !fetching) {
      dispatch(doFetch('PROFILE', fetchProfile().then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })));
    }

    if (!pnr) {
      Fetch('/idp-auth/pbasen/self-person').then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      }).then((result) => {
        this.setState({
          pnr: result.ssn,
        });
      }).catch((e) => {
        this.setState({
          error: true,
        });
      });
    }
  }

  render() {
    const {
      classes, addUser: { fetched, error: fetchError }, dispatch, history,
      profile: {
        fetched: profileFetched,
        fetching: profileFetching,
        error: profileFetchError,
        payload: profile,
      },
    } = this.props;
    const { localError, pnr, error } = this.state;

    if (error) {
      history.push('/');
    }

    return (
      <div className={classes.root}>
        <Typography variant="h4" className={classes.mb} color="primary">Registrer deg som politiker</Typography>
        {profileFetching && (
          <DefaultForm
            schema={schema}
            requiredFields
            additionalInfo="Opplysningene er hentet fra folkeregisteret"
            initialValues={{
              parti: '',
              fnr: '',
              fornavn: '',
              etternavn: '',
              adresse: '',
              gender: '',
              postnr: '',
              poststed: '',
              tlfprivat: '',
              arbeidssted: '',
              epost: '',
              bankkontonummer: '',
              generalInfo: '',
              // stilling: '',
            }}
            isLoading
            disabledFields={{
              fnr: true,
              fornavn: true,
              etternavn: true,
              adresse: true,
              postnr: true,
              poststed: true,
            }}
            onSubmit={() => {}}
          />
        )}
        {profileFetched && pnr && (
          <DefaultForm
            schema={schema}
            requiredFields
            additionalInfo="Opplysningene er hentet fra folkeregisteret"
            initialValues={{
              parti: '',
              fnr: pnr,
              // eslint-disable-next-line no-nested-ternary
              fornavn: !profileFetchError ? profile.mellomnavn ? `${profile.fornavn} ${profile.mellomnavn}` : profile.fornavn : '',
              etternavn: !profileFetchError ? profile.etternavn : '',
              adresse: !profileFetchError ? profile.adresse : '',
              gender: pnr[8] % 2 === 0 ? 'Kvinne' : 'Mann',
              postnr: !profileFetchError ? profile.postnummer : '',
              poststed: !profileFetchError ? profile.poststed : '',
              tlfprivat: '',
              arbeidssted: '',
              epost: '',
              bankkontonummer: '',
              generalInfo: '',
              // stilling: '',
            }}
            disabledFields={{
              fornavn: !!profile.fornavn,
              etternavn: !!profile.etternavn,
              adresse: !!profile.adresse,
              postnr: !!profile.postnummer,
              poststed: !!profile.poststed,
              fnr: !!pnr,
            }}
            onSubmit={(values) => {
              dispatch(doFetch(
                'ADD_POLITICIAN',
                fetchAddSelfPolitician({
                  ssn: values.fnr,
                  givenName: values.fornavn,
                  familyName: values.etternavn,
                  active: 2,
                  roles: ['politician'],
                  phone: values.tlfprivat,
                  email: values.epost,
                  sex: values.gender === 'Kvinne' ? 'f' : 'm',
                  streetAddress: values.adresse,
                  zipCode: values.postnr,
                  city: values.poststed,
                  workPlace: values.arbeidssted,
                  bankAccount: values.bankkontonummer,
                  generalInfo: values.generalInfo,
                  parties: [{
                    id: values.parti,
                  }],
                })
                  .then((res) => {
                    if (!res.ok) {
                      res.json().then(data => this.setState({ localError: data.error }));
                      throw res.statusText;
                    }
                    return res;
                  })
                  .then(() => {
                    history.push('/');
                    window.location.reload();
                  }),
              ));
            }
            }
          />
        )}
        {
          fetched && fetchError && localError !== 'Conflict' && (
            <NotificationBar message="Feil ved innsending" variant="error" />
          )
        }

      </div>
    );
  }
}

const styles = theme => ({
  submit: {
    width: '100%',
    marginTop: '2rem',
  },
  form: {
    maxWidth: '60rem',
    marginTop: '1rem',
    flexGrow: 1,
  },
  cancel: {
    color: '#fff',
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
    width: '100%',
    marginTop: '2rem',
  },
  gridItem: {
    paddingLeft: '0.8rem',
  },
  textfield: {
    width: '100%',
  },
  party: {
    width: '100%',
  },
  flex: {
    display: 'flex',
    justifyContent: 'center',
  },
  root: {
    maxWidth: '50rem',
    marginBottom: '4rem',
  },
});

Register.propTypes = {
  classes: PropTypes.object.isRequired,
  addUser: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  profile: PropTypes.any.isRequired,
  history: PropTypes.object.isRequired,
};

const mapStateToProps = ({ addUser, profile }) => ({ addUser, profile });

export default connect(mapStateToProps)(withRouter(withStyles(styles)(Register)));
